import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const KEY = 'sb-uls:GlobalInbox:popups';

const initialState = {
  popups: JSON.parse(localStorage.getItem(KEY) || '{}') as Record<string, number>,
};

const globalInboxSlice = createSlice({
  name: 'globalInbox',
  initialState,
  reducers: {
    openConversation: (
      state,
      action: PayloadAction<{ visitorId: string; conversationId: number }>,
    ) => {
      state.popups = {
        [action.payload.visitorId]: action.payload.conversationId,
      };
      localStorage.setItem(KEY, JSON.stringify(state.popups));
    },
    closeConversation: state => {
      state.popups = {};
      localStorage.setItem(KEY, '{}');
    },
  },
});

export const { openConversation, closeConversation } = globalInboxSlice.actions;
export default globalInboxSlice.reducer;
